import React from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';

const AdminDashboard = () => {
  const { currentUser, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/admin-login');
    } catch (error) {
      console.error('Failed to log out', error);
    }
  };

  return (
    <div style={{ padding: '40px', maxWidth: '800px', margin: '0 auto', textAlign: 'center' }}>
      <h1>Admin Dashboard</h1>
      <p style={{ margin: '20px 0', fontSize: '18px' }}>
        Welcome back, <strong>{currentUser?.email}</strong>
      </p>
      
      <div style={{ display: 'grid', gap: '20px', gridTemplateColumns: '1fr 1fr', marginTop: '40px' }}>
        <div style={{ padding: '30px', background: '#f8f9fa', borderRadius: '10px', border: '1px solid #ddd' }}>
          <h3>Manage Members</h3>
          <p>Review new signs ups, approve memberships, and manage existing PTPA user accounts.</p>
          <button style={{ padding: '10px 20px', background: '#007bff', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer', marginTop: '10px' }}>
            Go to Members
          </button>
        </div>
        
        <div style={{ padding: '30px', background: '#f8f9fa', borderRadius: '10px', border: '1px solid #ddd' }}>
          <h3>System Settings</h3>
          <p>Configure general website data and other admin-specific configurations.</p>
          <button style={{ padding: '10px 20px', background: '#6c757d', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer', marginTop: '10px' }}>
            Go to Settings
          </button>
        </div>
      </div>

      <button 
        onClick={handleLogout}
        style={{ marginTop: '50px', padding: '10px 30px', background: '#dc3545', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer' }}
      >
        Log Out Privileged Account
      </button>
    </div>
  );
};

export default AdminDashboard;
